export default __webpack_public_path__ + "img/f288f3e1197246fb9a927e8ee5116bd2.svg";